// src/admin/AdminDashboard.js

import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // To get the user's role
import { 
  CalendarDaysIcon, 
  UserGroupIcon, 
  EnvelopeIcon,
  PlusCircleIcon,
  ChartBarIcon,
  TicketIcon,
  ShoppingCartIcon, // Using a more distinct icon for orders
  UsersIcon,
  BookOpenIcon,
  ClipboardDocumentListIcon // Icon for the new User Management card
} from '@heroicons/react/24/outline';

// CORRECTED: This is your original DashboardCard component, restored completely.
const DashboardCard = ({ link, icon, title, description }) => (
  <Link to={link} className="dashboard-card-link">
    <div className="dashboard-card">
      <div className="dashboard-card-content">
        <div className="dashboard-card-icon">{icon}</div>
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="card-footer-action">
          Go to page &rarr;
        </div>
      </div>
    </div>
  </Link>
);


const AdminDashboard = () => {
  // Get the current user's data to check their role
  const { userData } = useAuth();

  // Define all possible cards, each with an 'allowedRoles' property
  const allCards = [
    {
      title: "Manage Messages",
      description: "Send newsletters and updates to your subscribers.",
      link: "/admin/manage-messages",
      icon: <TicketIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'marketing'] // Admins and Marketers
    },
    {
      title: "User Management",
      description: "View, edit roles, and manage all system users.",
      link: "/admin/manage-users",
      icon: <UsersIcon className="h-6 w-6" />,
      allowedRoles: ['admin'] // Only admins can see this
    },
    {
  title: "Task Board",
  description: "Manage team tasks, view progress and update statuses.",
  link: "/admin/manage-tasks",
  icon: <ClipboardDocumentListIcon className="h-6 w-6" />,
  allowedRoles: ['admin', 'editor', 'marketing']
},
{
  title: "Manage Book Pages",
  description: "Create landing pages and generate QR codes for your physical books.",
  link: "/admin/manage-book-pages",
  icon: <BookOpenIcon className="h-6 w-6" />,
  allowedRoles: ['admin', 'editor'] // Adjust roles as needed
},
    {
      title: "Sales Statistics",
      description: "View sales reports and performance metrics.",
      link: "/admin/statistics",
      icon: <ChartBarIcon className="h-6 w-6" />,
      allowedRoles: ['admin'] // Only admins can see this
    },
    {
      title: "Manage Orders",
      description: "View and manage all customer orders.",
      link: "/admin/manage-orders",
      icon: <ShoppingCartIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'order'] // Admins and Order Managers
    },
    {
      title: "Manage Events",
      description: "View, update, and manage all existing events.",
      link: "/admin/manage-events",
      icon: <CalendarDaysIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'editor'] // Admins and Editors
    },
    {
      title: "Add New Event",
      description: "Quickly create and publish a new community event.",
      link: "/admin/add-event",
      icon: <PlusCircleIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'editor'] // Admins and Editors
    },
    {
      title: "Manage Professionals",
      description: "Approve and manage listings in the professional directory.",
      link: "/admin/manage-professionals",
      icon: <UserGroupIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'marketing'] // Admins and Marketers
    },
    {
      title: "Email Campaigns",
      description: "Send newsletters and updates to your subscribers.",
      link: "/admin/manage-campaigns",
      icon: <EnvelopeIcon className="h-6 w-6" />,
      allowedRoles: ['admin', 'marketing'] // Admins and Marketers
    },
      
  ];

  // Filter the cards to show only the ones the user is allowed to see
  const visibleCards = allCards.filter(card => 
    userData && card.allowedRoles.includes(userData.role)
  );

  return (
    <>
      <div className="mb-4">
        <h1 className="fw-bold">Dashboard</h1>
        <p className="text-muted">Welcome back, {userData?.displayName || userData?.email}! Here's an overview of your site.</p>
      </div>

      <div className="row g-4">
        {visibleCards.map((card, index) => (
          // CORRECTED: Restored your original grid classes for a 4-column layout on large screens
          <div className="col-lg-3 col-md-6" key={index}> 
            <DashboardCard {...card} />
          </div>
        ))}
      </div>
    </>
  );
};

export default AdminDashboard;